import memoize from 'lru-memoize';
import React, {Component} from 'react';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {DropdownProps} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {ChannelModel} from '../../../../models/api/channelModel';
import {DeprecatedSearchDropdown} from '../../../common/dropdowns/search/deprecatedSearchDropdown';
import {RowRendererOf} from '../../../common/dropdowns/source/dropdownSource';
import {SyncDropdownSource} from '../../../common/dropdowns/source/syncDropdownSource';
import {ChannelDropdownItem} from './channelDropdownItem';

/*
 * Props.
 */

interface ChannelPickerDropdownProps extends DropdownProps {
  channel: ChannelModel;
  alternativeChannels: ReadonlyArray<ChannelModel>;
  onChannelSelected: HandlerOf<ChannelModel>;
}

/*
 * Component.
 */

export class PickChannelDropdown extends Component<ChannelPickerDropdownProps> {
  /*
   * Render.
   */

  render() {
    const {alternativeChannels} = this.props;
    const dropdownSource = new SyncDropdownSource({
      items: alternativeChannels,
      rowFilter: filterRows,
      renderRow: this.renderRow,
    });
    return (
      <DeprecatedSearchDropdown
        {...this.props}
        width={260}
        title={<Trans id="composer-channel-picker-title">Channels</Trans>}
        source={dropdownSource}
      />
    );
  }

  private readonly renderRow: RowRendererOf<ChannelModel> = (channel, index) => (
    <ChannelDropdownItem
      key={channel.id}
      index={index}
      currentChannel={this.props.channel}
      channel={channel}
      onSelect={() => this.props.onChannelSelected(channel)}
    />
  );
}

const filterRows = memoize(20)((channels: ReadonlyArray<ChannelModel>, query: string) => {
  // Shortcut for empty query.
  if (!query) {
    return channels;
  }

  // Otherwise, filter by name.
  const lowerCaseQuery = query.toLowerCase();
  return channels.filter((c) => c.displayName.toLowerCase().includes(lowerCaseQuery));
});
